<template>
<div id="container" class="container eiswelt">
  <div class="fullscreen_background">
    <img src="/static/assets/eiswelt/Hintergrund_2860.png" />
  </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
  <div class="miss_witch z30 dubix_animation">
  </div>
  <div class="libero z30">
<img class="img" src="/static/assets/eiswelt/animation_Liberdo.png" />
  </div>
  <div class="animation_tom z20">
<img class="img" src="/static/assets/eiswelt/animation_schneekoenig_tom.png" />
  </div>
  <div class="dubix z50">
    <img class="img" src="/static/assets/eiswelt/Dubix_roeslbauer.png" />
    
  </div>
  <div class="gigi z30">
<img class="img" src="/static/assets/eiswelt/Gigi_kristall.png" />   
  </div>
   <div class="hugi z40">
<img class="img" src="/static/assets/eiswelt/Hugi_hitz.png" />
  </div>
  <div class="glitzer z30">
    <img class="img" src="/static/assets/eiswelt/Glitzer_anim_2.png" />
  </div>
  <div class="eisfee z40">
    <img class="img hovering" src="/static/assets/eiswelt/Eisfee_Klirri_bitte_schweben_lassen.png" />
  </div>
  <div class="niko z35">
        <img class="img" src="/static/assets/eiswelt/Pony_niko.png" />
    </div>
  <div class="hase z40">
        <img class="img" src="/static/assets/eiswelt/schneehase_floeckchen.png" />
    </div>

  <!-- <router-link to="/maerchengeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/eiswelt/Pfeil.png" />
    </router-link> -->
  <!--div class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/eiswelt/Pfeil-1.png" />
    </div-->

  <router-link to="/dinowelt" tag="div" class="pfeil_links_big z50 pointer">
    <img class="img" src="/static/assets/alle/Pfeil.png" />
  </router-link>
  <router-link tag="div" to="geschichte_200601" class="pfeil_rechts_big z50 pointer">
    <img class="img" src="/static/assets/alle/Pfeil-1.png" />
  </router-link>

  <div class="geschichte z45">
    <div class="inner">
      <img src="/static/assets/eiswelt/Textfeld.png" usemap="#geschichte-map">
      <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichten_Langsam_GigiKristall.mp3" jsonurl="/static/assets/geschichten/gigi_ausgabe_6.json" content=".eiswelt" target="eiswelt_target" />
      <vuescrollbar tag="div" class="fliesstext" id="eiswelt_target">
<p>Schneekönig Tom saß auf einem weißbeflockten Erlenzweig und sang aus voller Vogelbrust einen Schneewalzer. Unter ihm wiegten sich seine FreundInnen Gigi Kristall und Libero Flocke im Takt und tanzten auf dem Eis. Schneehase Fröstchen kam herbeigehoppelt, spitzte seine Löffel und wippte sie im Takt hin und her. Nachdem Schneekönig Tom sein Lied beendet hatte, klatschte Gigi Kristall in die Hände. „Danke schön! Wenn du singst, kann ich unseren Kummer vergessen. Dann möchte ich mich ewig weiterdrehen, bis in den Himmel hinein, und der lieben Sonne Guten Tag sagen.“ Schwungvoll drehte sie eine Pirouette und Schneekönig Tom pfiff anerkennend. Auch Libero Flocke versuchte eine Pirouette, doch schon nach einer Runde fiel er — „Autsch!“ — auf sein Schnäuzchen. Gigi Kristall hob ihn auf und streichelte ihn zärtlich: „Du Dummerchen, du musst doch nicht alles nachmachen.“ Seufzend fuhr sie an den Rand der Eisfläche, schnallte sich und ihrem Hündchen die Kufen ab, versteckte sie in einem hohlen Baum und warf Schneehase Fröstchen zum Abschied eine Kusshand zu.</p>
<p>„Kommt, lasst uns nach Hause gehen!“ Schneekönig Tom flog auf ihre Schulter. Sie gingen über den knirschenden Schnee zu ihrem Schlitten und Pony Niko, das sie nach Hause zog. Über eine Allee, deren Bäume zu Eis gefroren waren, gelangten sie nach Dubeldorf, von dessen Häuserdächern riesige Eiszapfen herabhingen. Hier stand das stolze, alte Haus von Gigi Kristalls Familie. Im Frühling und Sommer war es stets über und über von duftenden Kletterrosen behangen. Doch am Ende des letzten Winters hatte Eisfee Klirri sich geweigert, das Land wieder zu verlassen und weiterzuwandern. So verharrte die Kälte seit langer, langer Zeit und nichts blühte und wuchs mehr.</p>
<p>Auf dem Marktplatz hatten sich die DubeldorferInnen versammelt. Sie waren mit Heugabeln, Spaten und Eispickeln bewaffnet und riefen drohend: „Klirri muss endlich weg! Wir können nichts säen und nichts ernten! Unsere Kinder haben bald nichts mehr zu essen!“ „Ruhe! Leute, bewahrt Ruhe!“, rief Gigi Kristalls Vater, Bürgermeister Dubix Röslbauer, mit dröhnender Stimme, „Gewalt ist keine Lösung, wir müssen Eisfee Klirri auf andere Art und Weise loswerden. Gebt mir noch einen Tag Zeit.“ Die wütenden DubeldorferInnen trollten sich und versicherten, nur noch einen Tag zu warten, dann aber würden sie Eisfee Klirri mit Gewalt vertreiben. Kurze Zeit später saßen Dubix Röslbauer, Gigi Kristall und ihr Bruder Hugi Hitz in der Küche ihres Hauses. „Einen Silberschlitten habe ich ihr angeboten, Ski aus purem Gold, diamantenbesetzte Schlittschuhe! Keine Reichtümer der Welt können Eisfee Klirri dazu bringen, unser Dorf zu verlassen. Ihr gefalle es hier so gut, entgegnet sie mir jedes Mal“, so sprach Dubix Röslbauer verzweifelt. Seine beiden Kinder dachten lange und angestrengt nach. Plötzlich erhellte sich Gigi Kristalls Gesicht. „Ich hab’s!“, jubelte sie laut, senkte ihre Stimme und berichtete ihrer Familie leise von ihrem Plan.</p>
<p>Noch am selben Abend sah man Hugi Hitz im Galopp davonreiten und am nächsten Tag begab sich Dubix Röslbauer mit seiner Tochter und Libero Flocke zum Eispalast am Rande des Dorfes. Eisfee Klirri empfing sie mit eisigem Blick. „Wenn ihr kommt, um mich zum Gehen zu bewegen, so sag ich euch, das könnt ihr euch sparen.“ „Nicht deshalb sind wir gekommen, werte Eisfee. Meine Tochter möchte euch die Zeit vertreiben und euch vorlesen“, erklärte Dubix Röslbauer. Eisfee Klirri, der es in ihrem Palast ziemlich langweilig war, gewährte ihnen die Bitte und ließ sich vorlesen. Es war eine superspannende Geschichte, in der ein gemeiner Dieb einem Jungen viel Geld stiehlt. Dieser jedoch verfolgt den Dieb durch eine große Stadt und immer mehr Kinder helfen ihm dabei. Eisfee Klirri lauschte gebannt. Doch plötzlich hörte Gigi Kristall auf zu lesen. „Lies weiter!“, herrschte Eisfee Klirri sie an. Doch Gigi Kristall hielt das Buch hoch. „Du siehst, ich habe nur das halbe Buch, die andere Hälfte brachte mein Bruder gestern nach Transalpinien. Dort sind die Leute müde vom Sommer und warten sehnlichst auf dich. Gerne lesen sie dir dort die andere Hälfte vor.“ Schnell wie Blitzeis packte Eisfee Klirri ihre Koffer und schlitterte auf Eisalleen und Schneeserpentinen davon ins Land hinter den Bergen.</p>
<p>In Dubeldorf kehrte endlich der Frühling ein und bald konnten seine BewohnerInnen unter dem Maibaum tanzen. Schneekönig Tom gab sein Bestes und pfiff aus voller Kehle den Frühlingsstimmenwalzer. Im Dreivierteltakt sangen die DubeldorferInnen dazu:</p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
  </div>

</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
/* eslint whitespace: "off" */
/* eslint indent: "off" */
/* eslint keyword-spacing: "off" */
/* eslint no-unused-vars: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Copyright from '@/components/Copyright.vue'
import Snowf from 'vue-snowf'
import Lautsprecher from '@/components/Lautsprecher.vue'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'eiswelt',
  data () {
    return {
      who: 'eiswelt',
      sternchen: '/static/assets/eiswelt/sternchen.png',
      audioposition: 0
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright, 
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () { 
    this.$ga.page(this.$router)
    var self = this
    setTimeout(function () {
      var muted = (typeof self.$root.muted !== 'undefined' ? self.$root.muted : false)
      try {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      try {
        window.currentAudio.pause()
        window.currentAudio.currentTime = 0
        window.currentAudio = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      window.currentAudioX = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies2021_GigiKristall.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }

      window.hintergrundSound = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Gigi_Kristall_AtmoV3.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined'?   window.muted : false)
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e) {
        window.bgsounddisabled = true
      }


    }, 1000);
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
      console.log('hintergrundsound nicht aktiv')
    }

  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

/* eiswelt */

.eiswelt {
  position: absolute;
  width: 1920px;
  height: 1080px;
  top: 0;
}

.eiswelt .himmel {
  display: block !important;
}

.eiswelt .geschichte {
  position: absolute;
  top: 170px;
  left: 51%;
}

.eiswelt .geschichte .inner {
  position: relative;
}



.eiswelt .pfeil_links_big {
  position: absolute;
  left: 1vw;
  top: 40%;
}

.eiswelt .pfeil_rechts_big {
  position: absolute;
  right: 1vw;
  top: 40%;
}

.eiswelt .moebel_vorne {
  position: absolute;
  bottom: 0;
  left: 0;
}

.eiswelt .miss_witch {
  position: absolute;
  /* top: 50%; left: 21%; */
  top: 47%;
  left: 23%;
}

.eiswelt .professor_riese {
  position: absolute;
    top: -354px;
    right: -640px;
  opacity:0;
  animation: riese_erscheint 1s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}

@keyframes riese_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    top: -100px !important;
    right: -1020px !important;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    top: -354px;
    right: -640px;
    opacity: 1;
  }
}

.eiswelt .libero {
  position: absolute;
top: -270px;
    left: -461px;
}

.eiswelt .libero {
  animation: libero_erscheint 2s ease-out;
  animation-delay: 2s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes libero_erscheint {
  50% {
    opacity: 0; 
  }
  100% {
    opacity: 1; 
  }
}

.eiswelt .hugi {
    position: absolute;
    top: 626px;
    left: 250px;
}  

.eiswelt .hugi img {
  animation-delay: 1s;
  animation: gigi_erscheint 1s;
  transform-origin: bottom center;
}  
  
.eiswelt .dubix {
    position: absolute;
    top: 630px;
    left: 810px;
}  

.eiswelt .dubix img {
  animation-delay: 2s;
  animation: gigi_erscheint 1s;
  transform-origin: bottom center;
}  
  
.eiswelt .gigi {
position: absolute;
    top: 805px;
    left: 768px;
}

.eiswelt .gigi img {
  animation-delay: 3s;
  animation: gigi_erscheint 1s;
  transform-origin: bottom center;
}

@keyframes gigi_erscheint {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  80% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.eiswelt .eisfee {
    position: absolute;
    top: 160px;
    left: 720px;
  animation: hexe_erscheint 10s linear;
  animation-delay: 0.75s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}  
.eiswelt .niko {
    position: absolute;
    top: 595px;
    left: 1005px;
  animation: niko_erscheint 5s linear;
  animation-delay: 2s;
  animation-fill-mode: forwards;
} 

@keyframes niko_erscheint {
  0% {
    top: 595px;
    left: 1005px;
  }
  100% {
    top: 585px;
    left: 685px;
  }
  }
  
  
.eiswelt .fliesstext {
    bottom: 34%;
    left: 13.5%;
    width: 74%;
  font-size: 16pt;
  font-family: 'Open Sans';
  font-weight: 400;
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 450px;
  padding-right: 15px;
}
.eiswelt .hase {
    position: absolute;
      top: 761px;
    left: 390px;
    height: 167px;
    animation: hase_skating 18s linear;
    animation-delay: 0.75s;
    animation-iteration-count: infinite;
}
  
@keyframes hase_skating {
  0% {
    left: 390px;
    top: 761px;
    transform: rotateY(0deg);  
  }
  15% {
    top: 741px;
  }
  30% {
  }
  45% {
    top: 791px;
  }
  50% {
  top: 781px;
  left: 90px;
  transform: rotateY(0deg); 
  }
  51% {
  transform: rotateY(-180deg);
  }
  60% {
  }
  75% {
    top: 741px;
  }
  97% {
  transform: rotateY(-180deg);  
  }
  98% {
    left: 400px;
    top: 761px;
  transform: rotateY(0deg);  
  }
  99% {
  }
  100% {
    left: 390px;
    top: 761px;
    transform: rotateY(0deg);  
  }
}  
  
.eiswelt .animation_tom.z20 {
    position: absolute;
    top: -265px;
    left: -480px;
  }
.eiswelt .animation_tom img{
  animation-delay: 4s;
  animation: tom_erscheint 1s;
  transform-origin: bottom center;
}
@keyframes tom_erscheint {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }
  50% {
    transform: scale(0.95);
    opacity: 0;
  }
  80% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}  
.eiswelt div.fliesstext>span {
  margin-right: 8px !important;
  float: left !important;
}

::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px #ac8a69;
  box-shadow: inset 0 0 0px #ac8a69;
  -webkit-border-radius: 0;
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #ac8a69;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #ac8a69;
}

::-webkit-scrollbar-button {
  background: none;
}

::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat;
}

::-webkit-scrollbar-button:vertical:decrement {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_up.png);
  background-position: 0px 0px;
}

::-webkit-scrollbar-button:vertical:increment {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_do.png);
  background-position: 0px 0px;
}

.snowf-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 150% !important;
  height: 150% !important;
  left: -25% !important;
  z-index: 30 !important;
}

.dubix_animation {
  width: 320px;
  height: 320px;
  animation-delay: 2s; 
  animation: play_dubix 4s steps(5) infinite;
  transform: scale(1);
  margin-top: -25px;
  margin-left: -50px;
}

@keyframes play_dubix {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -1600px;
  }
  100% {
    background-position: 0 -1600px;
  }
}

.globus {
  width: 350px;
  height: 350px; 
  animation-delay: 2s; 
  animation: play_globus 4s steps(6) infinite;
  transform: scale(0.465);
  top: -87px;
  left: 849px;
  position: absolute;
}

@keyframes play_globus {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -2100px;
  }
  100% {
    background-position: 0 -2100px;
  }
}
.kerze {
    width: 380px;
    height: 529px; 
    animation: play_kerze 2s steps(8) infinite;
    transform: scale(0.26);
    top: 533px;
    left: 728px;
    position: absolute;
}

.kugel.z30 {
  position: absolute;
  top: 420px;
  left: 350px;
}

.kugel {
  position: absolute;
  animation: hexe_erscheint 8s linear;
  animation-delay: 0s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
  margin-top: -800px;
}

@keyframes hexe_erscheint {
  0% {
    margin-top: 260px;
    opacity: 0;
    margin-left: 860px;
    transform: scale(0.5);
  }
  25% {
    opacity: 1;
  }
  100% {
    margin-left: 120px;
    opacity: 1;
    margin-top: 110px;
  }
}

.hovering {
  -webkit-animation: hovering 8s ease-in-out infinite;
  -moz-animation: hovering 8s ease-in-out infinite;
  -ms-animation: hovering 8s ease-in-out infinite;
  -o-animation: hovering 8s ease-in-out infinite;
  animation: hovering 8s ease-in-out infinite;
}

@-webkit-keyframes hovering
/* Safari and Chrome */

  {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

@keyframes hovering {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  /* 25% {
    -ms-transform: translate(-20px,20px);
    -moz-transform: translate(-20px,20px);
    -webkit-transform: translate(-20px,20px);
    -o-transform: translate(-20px,20px);
    transform: translate(-20px,20px);
  }
 */
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  /*  75% {

    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
*/
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}
span {
  font-family: FrozenMemory;
}
.player{
    position: absolute;
    top: 700px;
    left: 130px;
    width: 475px;
}
.eiswelt .player .inner {
    top: -73px;
}
</style> 



// WEBPACK FOOTER //
// src/components/Eiswelt.vue